import { useContext } from 'react'
import StripePaymentContext from './stripe-payment-provider/StripePaymentProvider'

export const useStripePaymentContext = () => {
  return useContext(StripePaymentContext)
}
